import React from 'react'
import './DetailService.css'
export default function DetailService() {
    return (
        <div>
            <h1>Detail Service Page</h1>
        </div>
    )
}
